/**
 * Copyright (c) 2020, 2021, 2023, 2024 Visa, Inc.
 *
 * This source code is licensed under the MIT license
 * https://github.com/visa/visa-chart-components/blob/master/LICENSE
 *
 **/
heat-map {
  .annotations {
    pointer-events: none;
    .handle {
      pointer-events: all;
    }
  }

  .screen-reader-info {
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  .vcc-style-visibility-hidden {
    visibility: hidden;
  }

  .vcc-style-display-none {
    display: none;
  }

  .vcc-style-display-block {
    display: block;
  }

  .vcc-style-point-events-none {
    pointer-events: none;
  }

  .vcc-style-cursor-pointer {
    cursor: pointer;
  }

  .vcc-style-cursor-default {
    cursor: default;
  }

  .data-table-link {
    color: #767676;
    text-decoration: none;
    font-size: 12px;
    margin-left: 5%;
  }

  .hidden {
    display: none;
  }

  cursor: default;
  .axis {
    font-size: 12px;
    text {
      //font: 0.65rem;
      fill: #767676;
    }

    &-label {
      text-anchor: middle;
      font: 1rem sans-serif;
    }
    path {
      stroke: #767676;
    }
    .hidden {
      visibility: hidden;
    }
  }
  .heat-map-legend {
    font-size: 1em;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .legend {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
  }
}
